import { SampleTable, SingleTableBoxScene } from "@/shared/components/ui";
import { Grid } from "@mui/material";
import { useGetActivityType } from "../actions/noc-module.actions";
import { ActivityType } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { ROUTER_PATHS } from "@/shared";
import { useEffect, useState } from "react";
import { useTableColumnsActivityType } from "../hooks/useTableColumnsActivityType";
import { Add } from "@mui/icons-material";

export default function TabTipoActividadNoc() {

    const ordenesDeTrabajoNocParametrosCrearPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosTipoActividadCrearNav;

    const { columnsActivityType } = useTableColumnsActivityType();

    const [listaTipoActividad, setListaTipoActividad] = useState<any[]>([]);
    const useActivityTypeMutation = useGetActivityType();

    useEffect(() => {
        const fetchData = async () => {
            const response = await useActivityTypeMutation.mutateAsync([]);
            setListaTipoActividad(response.data ?? []);
        };
        fetchData();
    }, []);

    return (
        <SingleTableBoxScene
            title={``}
            textRedirect={"Crear Tipo Actividad"}
            iconRedirect={<Add />}
            urlRedirect={`${ordenesDeTrabajoNocParametrosCrearPage}`}
            visibleReport={true}
        >
            <Grid container spacing={2}>
                <Grid item xs={12}>

                </Grid>
                <Grid item xs={12}>
                    <SampleTable<ActivityType>
                        columns={columnsActivityType}
                        data={listaTipoActividad}
                    />
                </Grid>
            </Grid>
        </SingleTableBoxScene>
    );
}